import React from "react";
import NavPanel from "../Common/Nav/NavPanel.jsx";
import PropTypes from "prop-types";


class AdminMenu extends React.PureComponent {

    componentWillMount() {

        if (this.props.show && !this.props.general.data) {
            this.props.loadGeneral();
        }
        if (this.props.show && this.props.gameId) {
            this.props.loadInGame(this.props.gameId);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.show || !nextProps.gameId) {
            return;
        }

        if (nextProps.gameId !== this.props.gameId) {
            nextProps.loadInGame(nextProps.gameId);
        }
    }

    render() {
        if (!this.props.show) {
            return null;
        }
        return <div>
            {this.props.gameId ? <AdminMenuPart links={this.props.inGame.data} title="Game Admin"/> : null}
            <AdminMenuPart links={this.props.general.data} title="Site Admin"/>
        </div>;
    }

    static propTypes = {
        show: PropTypes.bool,
        gameId: PropTypes.number,
        loadInGame: PropTypes.func.isRequired,
        loadGeneral: PropTypes.func.isRequired,
        generaLinks: PropTypes.arrayOf(PropTypes.shape(
            {
                'name': PropTypes.string,
                'url': PropTypes.string,
            }
        )),
        inGameLinks: PropTypes.arrayOf(PropTypes.shape(
            {
                'name': PropTypes.string,
                'url': PropTypes.string,
            }
        )),
    }
}

const AdminMenuPart = ({title, links}) => {
    if (!links) {
        return null;
    }

    return <NavPanel
        collapsible
        collapsed
        name={title}
        items={links}
        itemType="external"
    />;
};

export default AdminMenu;